var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 10.6276C7.40266 10.6276 6.09766 9.33008 6.09766 7.72508C6.09766 6.12008 7.40266 4.83008 9.00016 4.83008C10.5977 4.83008 11.9027 6.12758 11.9027 7.73258C11.9027 9.33758 10.5977 10.6276 9.00016 10.6276ZM9.00016 5.95508C8.02516 5.95508 7.22266 6.75008 7.22266 7.73258C7.22266 8.71508 8.01766 9.51008 9.00016 9.51008C9.98266 9.51008 10.7777 8.71508 10.7777 7.73258C10.7777 6.75008 9.97516 5.95508 9.00016 5.95508Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99977 17.07C7.88977 17.07 6.77227 16.65 5.90227 15.8175C3.68977 13.6875 1.24477 10.29 2.16727 6.2475C2.99977 2.58 6.20227 0.9375 8.99977 0.9375C8.99977 0.9375 8.99977 0.9375 9.00727 0.9375C11.8048 0.9375 15.0073 2.58 15.8398 6.255C16.7548 10.2975 14.3098 13.6875 12.0973 15.8175C11.2273 16.65 10.1098 17.07 8.99977 17.07ZM8.99977 2.0625C6.81727 2.0625 4.01227 3.225 3.26977 6.495C2.45977 10.0275 4.67977 13.0725 6.68977 15C7.98727 16.2525 10.0198 16.2525 11.3173 15C13.3198 13.0725 15.5398 10.0275 14.7448 6.495C13.9948 3.225 11.1823 2.0625 8.99977 2.0625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation3);
export default __webpack_public_path__ + "static/media/location-3.3b3cf7cdb1a816707f5ec448348399ff.svg";
export { ForwardRef as ReactComponent };